import * as angular from 'angular';
import * as moment from 'moment';
import * as toastr from 'toastr';

import * as events from '../../common/events';

export interface ILoggerFunction {
    (message: string, showToast?: boolean, data?: Object, source?: string, sendNotification?: boolean): void;
}

export interface ILoggerService {
    log: ILoggerFunction;
    logSuccess: ILoggerFunction;
    logWarning: ILoggerFunction;
    logError: ILoggerFunction;
}

export class LoggerService implements ILoggerService {

    static serviceId = 'loggerService';
    static $inject = ['$rootScope', '$log'];

    constructor(private $rootScope: angular.IRootScopeService,
        private $log: angular.ILogService) {
    }

    log(message: string, showToast?: boolean, data?: Object, source?: string, sendNotification?: boolean): void {
        this.logIt(message, data, source, showToast, 'info', sendNotification);
    }

    logSuccess(message: string, showToast?: boolean, data?: Object, source?: string, sendNotification?: boolean): void {
        this.logIt(message, data, source, showToast, 'success', sendNotification);
    }

    logWarning(message: string, showToast?: boolean, data?: Object, source?: string, sendNotification?: boolean): void {
        this.logIt(message, data, source, showToast, 'warning', sendNotification);
    }

    logError(message: string, showToast?: boolean, data?: Object, source?: string, sendNotification?: boolean): void {
        this.logIt(message, data, source, showToast, 'error', sendNotification);
    }

    private logIt(message: string, data: Object, source: string, showToast: boolean, toastType: string, sendNotification: boolean): void {
        // write in console
        // http://stackoverflow.com/questions/25532778/node-js-console-log-vs-console-info
        switch (toastType) {
            case 'success':
                console.info(message);
                break;
            case 'warning':
                console.warn(message);
                break;
            case 'error':
                console.error(message);
                break;
            default:
                console.info(message);
        }

        // show toast if needed
        if (typeof showToast == 'undefined') {
            showToast = true;
        }
        if (showToast) {
            switch (toastType) {
                case 'success':
                    toastr.success(message);
                    break;
                case 'warning':
                    toastr.warning(message);
                    break;
                case 'error':
                    toastr.error(message);
                    break;
                default:
                    toastr.info(message);
            }
        }

        // send to notifications
        if (typeof sendNotification == 'undefined') {
            sendNotification = true;
        }
        if (sendNotification) {
            this.$rootScope.$broadcast(events.sendNotification, { message: message, severity: toastType, date: moment().toString() });
        }
    }
}